import { Field, FieldArray, Formik } from 'formik';
import { formTools, FormData } from './trusted-ips.form-tools';
import { SwitchField } from 'shared/ui/formik-fields/switch-field';
import { TextField } from 'formik-mui';
import {  Box, Button, Card, Stack } from '@mui/material';
import { useTrustedIpsSettings } from './use-trusted-ips-settings.hook';
import { LoadingBanner } from 'shared/ui/loading-banner';
import { ErrorBanner } from 'shared/ui/error-banner';
import { extractNestJsErrorMessage } from 'shared/api/rtk-query';
import { useSnack } from 'shared/ui/snack';


export const TrustedIpsForm = () => {
  const { data, isLoading, error, update } = useTrustedIpsSettings();
  const { showError, showSuccess } = useSnack();
  const handleSubmit = async (values: FormData) => {
    await update(formTools.toCreateDto(values))
      .then(() => showSuccess('Настройки обновлены'))
      .catch((e: unknown) => showError(`Ошибка обновления настроек: ${extractNestJsErrorMessage(e)}`));
  };

  if (isLoading) return <LoadingBanner />;
  if (error) return <ErrorBanner errorMessage={extractNestJsErrorMessage(error)} />;
  return (
    <Formik
      initialValues={data ? formTools.fromDto(data) : formTools.emptyValues()}
      onSubmit={handleSubmit}
      validate={formTools.validate}
    >
      {({ submitForm, dirty, isValid, values }) => <>
        <Card sx={{ p: 2 }}>
          <Stack direction="column" spacing={2}>
            <Field
              name="enabled"
              label="Включить глобальное ограничение IP-адресов"
              type="checkbox"
              component={SwitchField}
            />
            <FieldArray name="trustedIps">
              {({ push, remove }) => (
                <Stack spacing={1}>
                  <Box fontWeight="bold">Доверенные IP-адреса</Box>
                  {values.trustedIps.map((ip, idx) => (
                    <Box key={idx} display="flex" alignItems="center" gap={1}>
                      <Field
                        name={`trustedIps.${idx}`}
                        component={TextField}
                        label={`IP #${idx + 1}`}
                      />
                      <Button
                        variant="outlined"
                        color="error"
                        size="small"
                        onClick={() => remove(idx)}
                        disabled={values.trustedIps.length === 1}
                      >Удалить</Button>
                    </Box>
                  ))}
                  <Button variant="outlined" size="small" onClick={() => push('')}>Добавить IP</Button>
                </Stack>
              )}
            </FieldArray>
            <Box display="flex" justifyContent="flex-end">
              <Button variant='contained' color='primary' size='small' onClick={submitForm} disabled={!dirty || !isValid}>Сохранить</Button>
            </Box>
          </Stack>
        </Card>
      </>}
    </Formik>
  );
};
